<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="512px" height="512px" viewBox="-35 0 511 512" fill="currentColor">
    <path d="M436 107L331.4 4.3A15 15 0 00321 0H56.5a56 56 0 00-56 56v400a56 56 0 0056 56h328a56 56 0 0056-56V117.7c0-4-1.6-7.8-4.5-10.7zM336 50.8l52.8 52h-48.1a4.8 4.8 0 01-4.8-4.8zM384.5 482H56.5a26 26 0 01-26-26V56a26 26 0 0126-26h249.4v68a34.8 34.8 0 0034.8 34.7h69.8V456a26 26 0 01-26 26zm0 0"/>
    <path d="M324.6 238H113.2a15 15 0 100 30h211.4a15 15 0 100-30zm0 0M113.2 328h172.4a15 15 0 100-30H113.2a15 15 0 100 30zm0 0M306.4 358H113.2a15 15 0 100 30h193.2a15 15 0 000-30zm0 0"/>
  </svg>
</template>

<script>
export default {
  name: 'FileIcon'
}
</script>
